import { deletionPeriod, DeletionCriteria, isoCountryCodes, RecipientCategory, RiskLevel, ThirdCountryGuarantees } from '../interfaces/gdpr-processing-activities';

import { DataCategory, DataSubjectCategory, LegalBasis, ProcessingPurposes, TechnicalMeasure } from "../interfaces/gdpr-processing-activities"

export const gdprCategories: { value: DataCategory, label: string }[] = [
  { value: DataCategory.BASIC_DATA, label: 'Name, Kontaktdaten' },
  { value: DataCategory.IDENTIFICATION_DATA, label: 'Ausweisnummer, Kundennummer' },
  { value: DataCategory.LOCATION_DATA, label: 'Standortdaten' },
  { value: DataCategory.COMMUNICATION_DATA, label: 'E-Mail, Telefon' },
  { value: DataCategory.FINANCIAL_DATA, label: 'Bankverbindung, Zahlungsdaten' },
  { value: DataCategory.CONTRACT_DATA, label: 'Vertragsdaten' },
  { value: DataCategory.USAGE_DATA, label: 'Nutzungsverhalten, Logs' },
  { value: DataCategory.TECHNICAL_DATA, label: 'IP-Adresse, Browser' },
  { value: DataCategory.HEALTH_DATA, label: 'Gesundheitsdaten' },
  { value: DataCategory.BIOMETRIC_DATA, label: 'Biometrische Daten' },
  { value: DataCategory.GENETIC_DATA, label: 'Genetische Daten' },
  { value: DataCategory.SPECIAL_CATEGORIES, label: 'Besondere Kategorien' },
]

export const gdprLegalBases: { value: LegalBasis, label: string }[] = [
  { value: LegalBasis.CONSENT, label: 'Einwilligung' },
  { value: LegalBasis.CONTRACT, label: 'Vertragserfüllung' },
  { value: LegalBasis.LEGAL_OBLIGATION, label: 'Rechtliche Verpflichtung' },
  { value: LegalBasis.VITAL_INTERESTS, label: 'Lebenswichtige Interessen' },
  { value: LegalBasis.PUBLIC_INTEREST, label: 'Öffentliches Interesse' },
  { value: LegalBasis.LEGITIMATE_INTEREST, label: 'Berechtigtes Interesse' },
]

export const gdprTechnicalMeasures: { value: TechnicalMeasure, label: string }[] = [
  { value: TechnicalMeasure.BACKUP, label: 'Regelmäßige Backups' },
  { value: TechnicalMeasure.TRAINING, label: 'Mitarbeiterschulungen' },
  { value: TechnicalMeasure.ENCRYPTION, label: 'Datenverschlüsselung' },
  { value: TechnicalMeasure.ACCESS_CONTROL, label: 'Zugriffskontrollen' },
  { value: TechnicalMeasure.SECURITY_TESTING, label: 'Sicherheitstests' },
  { value: TechnicalMeasure.DATA_MINIMIZATION, label: 'Datenminimierung' },
  { value: TechnicalMeasure.INCIDENT_RESPONSE, label: 'Vorfallreaktionspläne' },
  { value: TechnicalMeasure.PSEUDONYMIZATION, label: 'Pseudonymisierung' },
]

export const gdprProcessingPurposes: { value: ProcessingPurposes, label: string }[] = [
  { value: ProcessingPurposes.SERVICE_PROVISION, label: 'Bereitstellung von Dienstleistungen' },
  { value: ProcessingPurposes.MARKETING, label: 'Marketing und Werbung' },
  { value: ProcessingPurposes.CUSTOMER_MANAGEMENT, label: 'Kundenverwaltung' },
  { value: ProcessingPurposes.COMPLIANCE, label: 'Einhaltung gesetzlicher Vorschriften' },
  { value: ProcessingPurposes.RESEARCH_AND_ANALYSIS, label: 'Forschung und Analyse' },
]

export const gdprDataSubjectCategories: { value: DataSubjectCategory, label: string }[] = [
  { value: DataSubjectCategory.EMPLOYEES, label: 'Mitarbeiter' },
  { value: DataSubjectCategory.CUSTOMERS, label: 'Kunden' },
  { value: DataSubjectCategory.SUPPLIERS, label: 'Lieferanten' },
  { value: DataSubjectCategory.APPLICANTS, label: 'Bewerber' },
  { value: DataSubjectCategory.WEBSITE_VISITORS, label: 'Website-Besucher' },
  { value: DataSubjectCategory.INTERESTED_PARTIES, label: 'Interessenten' },
  { value: DataSubjectCategory.NEWSLETTER_SUBSCRIBERS, label: 'Newsletter-Abonnenten' },
  { value: DataSubjectCategory.PARTNERS, label: 'Geschäftspartner' },
  { value: DataSubjectCategory.OTHERS, label: 'Sonstige' },
]
export const gdprRecipientCategories: { value: RecipientCategory; label: string }[] = [
  { value: RecipientCategory.IT_SERVICE_PROVIDER, label: 'IT-Dienstleister' },
  { value: RecipientCategory.CLOUD_HOSTING, label: 'Cloud-Hosting-Anbieter' },
  { value: RecipientCategory.CLOUD_STORAGE, label: 'Cloud-Storage-Anbieter' },
  { value: RecipientCategory.EMAIL_SERVICE, label: 'E-Mail-Service-Provider' },
  { value: RecipientCategory.PAYMENT_PROVIDER, label: 'Zahlungsdienstleister' },
  { value: RecipientCategory.MARKETING_TOOLS, label: 'Marketing-Tools' },
  { value: RecipientCategory.ANALYTICS_PROVIDER, label: 'Analytics-Anbieter' },
  { value: RecipientCategory.AI_SERVICE_PROVIDER, label: 'KI-Service-Provider' },
  { value: RecipientCategory.SUPPORT_TOOLS, label: 'Support-/Helpdesk-Tools' },
  { value: RecipientCategory.ACCOUNTING_SERVICE, label: 'Buchhaltungsservice' },
  { value: RecipientCategory.LEGAL_SERVICE, label: 'Rechtsdienstleister' },
  { value: RecipientCategory.AUTHORITIES, label: 'Behörden' },
  { value: RecipientCategory.INSURANCE_PROVIDER, label: 'Versicherungen' },
  { value: RecipientCategory.BANKING_INSTITUTION, label: 'Banken/Finanzinstitute' },
  { value: RecipientCategory.TELECOMMUNICATION, label: 'Telekommunikationsanbieter' },
  { value: RecipientCategory.LOGISTICS_PROVIDER, label: 'Logistik-/Versanddienstleister' },
  { value: RecipientCategory.RESEARCH_INSTITUTION, label: 'Forschungseinrichtungen' },
  { value: RecipientCategory.BUSINESS_PARTNER, label: 'Geschäftspartner' },
  { value: RecipientCategory.SUBCONTRACTOR, label: 'Unterauftragnehmer' },
  { value: RecipientCategory.GROUP_COMPANIES, label: 'Konzernunternehmen' },
  { value: RecipientCategory.OTHER, label: 'Sonstige' },
];

export const gdprThirdCountryGuarantees: { value: ThirdCountryGuarantees; label: string }[] = [
  { value: ThirdCountryGuarantees.NONE, label: 'Keine' },
  { value: ThirdCountryGuarantees.EU_STANDARD_CONTRACTUAL_CLAUSES, label: 'Standardvertragsklauseln' },
  { value: ThirdCountryGuarantees.BINDING_CORPORATE_RULES, label: 'Verbindliche Unternehmensregeln' },
  { value: ThirdCountryGuarantees.CODES_OF_CONDUCT_CERTIFICATIONS, label: 'Verhaltenskodizes/Zertifizierungen' },
  { value: ThirdCountryGuarantees.ADEQUACY_DECISION, label: 'Angemessenheitsbeschluss' },
  { value: ThirdCountryGuarantees.DATA_SUBJECT_CONSENT, label: 'Einwilligung des Betroffenen' },
  { value: ThirdCountryGuarantees.EXCEPTIONS_ART_49, label: 'Ausnahmen gemäß Art. 49 DSGVO' },
  { value: ThirdCountryGuarantees.OTHERS, label: 'Sonstige' },
];
export const gdprDeletionPeriod: { value: deletionPeriod; label: string }[] = [
  { value: deletionPeriod.THREE_YEARS_AFTER_LAST_ACTIVITY, label: '3 Jahre nach letzter Aktivität' },
  { value: deletionPeriod.NINETY_DAYS_AFTER_CREATION, label: '90 Tage nach Erstellung' },
  { value: deletionPeriod.SIX_MONTHS_AFTER_REJECTION, label: '6 Monate nach Ablehnung' },
  { value: deletionPeriod.UPON_ACCOUNT_DELETION, label: 'Bei Löschung des Accounts' },
  { value: deletionPeriod.AFTER_CONTRACT_END, label: 'Nach Vertragsende' },
  { value: deletionPeriod.UPON_USER_REQUEST, label: 'Auf Anfrage des Nutzers' },
  { value: deletionPeriod.TEN_YEARS_SECTION_147_AO, label: '10 Jahre (§147 AO)' },
  { value: deletionPeriod.SIX_YEARS_SECTION_257_HGB, label: '6 Jahre (§257 HGB)' },
  { value: deletionPeriod.TEN_YEARS_AFTER_CONTRACT_END_OR_REQUEST, label: '10 Jahre nach Vertragsende oder auf Anfrage' },
  { value: deletionPeriod.UNTIL_MANUAL_DELETION_BY_USER, label: 'Bis zur manuellen Löschung durch den Nutzer' },
];

export const gdprDeletionCriteria: { value: DeletionCriteria; label: string }[] = [
  { value: DeletionCriteria.AUTOMATED_TIME_BASED, label: 'Automatische zeitbasierte Löschung' },
  { value: DeletionCriteria.AUTOMATED_EVENT_BASED, label: 'Automatische ereignisbasierte Löschung' },
  { value: DeletionCriteria.MANUAL_USER_REQUEST, label: 'Manuelle Löschung auf Nutzeranfrage' },
  { value: DeletionCriteria.MANUAL_ADMIN_REVIEW, label: 'Manuelle Löschung nach Admin-Prüfung' },
  { value: DeletionCriteria.LEGAL_RETENTION_PERIOD, label: 'Gesetzliche Aufbewahrungspflicht' },
  { value: DeletionCriteria.CONTRACT_END_TRIGGERED, label: 'Vertragsende als Löschauslöser' },
  { value: DeletionCriteria.GDPR_RIGHT_TO_ERASURE, label: 'DSGVO Recht auf Löschung (Art. 17)' },
  { value: DeletionCriteria.TECHNICAL_OVERWRITE, label: 'Technisches Überschreiben' },
  { value: DeletionCriteria.ARCHIVING_THEN_DELETE, label: 'Archivierung vor Löschung' },
  { value: DeletionCriteria.ANONYMIZATION_INSTEAD, label: 'Anonymisierung statt Löschung' },
];

export const gdprRiskLevels: { value: RiskLevel; label: string }[] = [
  { value: RiskLevel.NO_RISK, label: 'Kein Risiko - Routine-Verarbeitungen ohne Risiko' },
  { value: RiskLevel.LOW_RISK, label: 'Geringes Risiko - Minimale Auswirkungen bei Datenschutzverletzung' },
  { value: RiskLevel.NORMAL_RISK, label: 'Normales Risiko - Standard-Verarbeitungen mit üblichen Schutzmaßnahmen' },
  { value: RiskLevel.HIGH_RISK, label: 'Hohes Risiko - Erhebliche Auswirkungen möglich, aber Schutzmaßnahmen vorhanden' },
  { value: RiskLevel.VERY_HIGH_RISK, label: 'Sehr hohes Risiko - Schwerwiegende Folgen möglich (Art. 35 DSGVO - DSFA erforderlich!)' },
];

export const gdprThirdCountries: { value: isoCountryCodes; label: string, isThirdCountry: boolean }[] = [
  // EU-Länder (zur Referenz, kein Drittland)
  { value: isoCountryCodes.AT, label: 'Österreich', isThirdCountry: false },
  { value: isoCountryCodes.BE, label: 'Belgien', isThirdCountry: false },
  { value: isoCountryCodes.BG, label: 'Bulgarien', isThirdCountry: false },
  { value: isoCountryCodes.HR, label: 'Kroatien', isThirdCountry: false },
  { value: isoCountryCodes.CY, label: 'Zypern', isThirdCountry: false },
  { value: isoCountryCodes.CZ, label: 'Tschechien', isThirdCountry: false },
  { value: isoCountryCodes.DK, label: 'Dänemark', isThirdCountry: false },
  { value: isoCountryCodes.EE, label: 'Estland', isThirdCountry: false },
  { value: isoCountryCodes.FI, label: 'Finnland', isThirdCountry: false },
  { value: isoCountryCodes.FR, label: 'Frankreich', isThirdCountry: false },
  { value: isoCountryCodes.DE, label: 'Deutschland', isThirdCountry: false },
  { value: isoCountryCodes.GR, label: 'Griechenland', isThirdCountry: false },
  { value: isoCountryCodes.HU, label: 'Ungarn', isThirdCountry: false },
  { value: isoCountryCodes.IE, label: 'Irland', isThirdCountry: false },
  { value: isoCountryCodes.IT, label: 'Italien', isThirdCountry: false },
  { value: isoCountryCodes.LV, label: 'Lettland', isThirdCountry: false },
  { value: isoCountryCodes.LT, label: 'Litauen', isThirdCountry: false },
  { value: isoCountryCodes.LU, label: 'Luxemburg', isThirdCountry: false },
  { value: isoCountryCodes.MT, label: 'Malta', isThirdCountry: false },
  { value: isoCountryCodes.NL, label: 'Niederlande', isThirdCountry: false },
  { value: isoCountryCodes.PL, label: 'Polen', isThirdCountry: false },
  { value: isoCountryCodes.PT, label: 'Portugal', isThirdCountry: false },
  { value: isoCountryCodes.RO, label: 'Rumänien', isThirdCountry: false },
  { value: isoCountryCodes.SK, label: 'Slowakei', isThirdCountry: false },
  { value: isoCountryCodes.SI, label: 'Slowenien', isThirdCountry: false },
  { value: isoCountryCodes.ES, label: 'Spanien', isThirdCountry: false },
  { value: isoCountryCodes.SE, label: 'Schweden', isThirdCountry: false },

  // EWR-Länder (kein Drittland)
  { value: isoCountryCodes.IS, label: 'Island', isThirdCountry: false },
  { value: isoCountryCodes.LI, label: 'Liechtenstein', isThirdCountry: false },
  { value: isoCountryCodes.NO, label: 'Norwegen', isThirdCountry: false },

  // Länder mit Angemessenheitsbeschluss
  { value: isoCountryCodes.CH, label: 'Schweiz', isThirdCountry: true },
  { value: isoCountryCodes.GB, label: 'Vereinigtes Königreich', isThirdCountry: true },
  { value: isoCountryCodes.UK, label: 'Vereinigtes Königreich', isThirdCountry: true },
  { value: isoCountryCodes.JP, label: 'Japan', isThirdCountry: true },
  { value: isoCountryCodes.CA, label: 'Kanada', isThirdCountry: true },
  // Drittländer (benötigen Garantien)
  { value: isoCountryCodes.US, label: 'Vereinigte Staaten', isThirdCountry: true },
  { value: isoCountryCodes.AU, label: 'Australien', isThirdCountry: true },
];
